export default __webpack_public_path__ + "static/media/AAE-Fire-Fx-03.d4726110.jpg";